import qs from "qs"

const Cookie = process.client ? require('js-cookie') : undefined

export default function ({ $axios, store, redirect, app, error: nuxtError }) {

  $axios.defaults.paramsSerializer = function(params) {
    return qs.stringify(params)
  }

  $axios.onRequest(config => {
    let url_split = config.url.split('.')[0],
        url_master = url_split.split('//')[1]
    config.headers.common['Authorization'] = url_master !== 'master' ? process.env.API_SECRET : process.env.API_SECRET_MASTER
    config.headers.common['token'] = `${store.state.member.auth.token}`
    config.headers.common['x-api-key'] = process.env.API_AUTH
  })

  $axios.onError(error => {
    const code = parseInt(error.response && error.response.status)
    
    if (code === 400) {
      redirect('/500')
    }

    if (code === 401) {
      Cookie.remove('token')
      Cookie.remove('user')
      Cookie.remove('fcm')
      Cookie.remove('notif')

      // redirect('/auth/login')
    }

    if (code === 500) {
      redirect('/500')
    }

    nuxtError({
      statusCode: error.response.status,
      message: error.message,
    })
    return Promise.resolve(false)
  })
}

